<template>
  <v-card flat>
    <v-container>
      <div class="">
        <h4 class="earth-color">ADD ACTIVITY CONTACTS</h4>
      </div>
      <div >
        <v-form  @submit.prevent="_addContact()">
          <v-layout row wrap>
            <v-flex lg6 md6 sm12 xs12>
              <v-container>
                <v-text-field
                  type="email"
                  label="Contact Email"
                  v-model="details_.contact_email"
                  :rules="requiredRules"
                  required
                ></v-text-field>
              </v-container>
            </v-flex>
            <v-flex lg6 md6 sm12 xs12>
              <v-container>
                <v-btn :depressed="true" block color="primary" type="submit">Add to Notification List</v-btn>
              </v-container>
            </v-flex>
          </v-layout>
        </v-form>
      </div>
        <div class="col-md-12">
          <table class="table table-bordered">
            <thead>
            <tr>
              <td>Date Created</td>
              <td>Email</td>
              <td>Action</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(_contact, key) in inventoryContact" :key="key">
              <td>{{formated_date(_contact.created_at)}}</td>
              <td>{{_contact.email}}</td>
              <td>
                <v-btn :depressed="true" small color="warning" v-if="_contact.status === 5" @click="disableContact(_contact.public_id)">Disable</v-btn>
                <v-btn :depressed="true" small color="error" v-if="_contact.status === 7" @click="deleteContact(_contact.public_id)">Delete</v-btn>
                <v-btn :depressed="true" small color="success" v-if="_contact.status === 7" @click="enableContact(_contact.public_id)">Enable</v-btn>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </v-container>
    </v-card>
</template>

<script>
export default {
  name: 'inventory-contacts',
  data () {
    return {
      requiredRules: [
        v => !!v || 'This field is required'
      ],
      details_: {
        contact_email: '',
        inventory_id: this.$route.params.inventory_id,
        session_id: localStorage.getItem('lkjhgfdsa')
      }
    }
  },
  created () {
    this.$store.dispatch('get_activity_contacts', this.$route.params.inventory_id)
  },
  methods: {
    disableContact: function (publicId) {
      var data = {
        public_id: publicId,
        deleted_by: localStorage.getItem('lkjhgfdsa'),
        inventory_id: this.$route.params.inventory_id
      }
      this.$store.dispatch('make_activity_contact_in_active', data)
      this.$store.dispatch('get_activity_contacts', this.$route.params.inventory_id)
    },
    enableContact: function (publicId) {
      var data = {
        public_id: publicId,
        inventory_id: this.$route.params.inventory_id
      }
      this.$store.dispatch('make_activity_contact_active', data)
      this.$store.dispatch('get_activity_contacts', this.$route.params.inventory_id)
    },
    _addContact: function () {
      // var instance = this
      this.$store.dispatch('post_activity_contact', this.details_)
      this.$store.dispatch('get_activity_contacts', this.$route.params.inventory_id)
      // this.details_.contact_email = ''
    },
    deleteContact: function (publicId) {
      var data = {
        public_id: publicId,
        inventory_id: this.$route.params.inventory_id,
        deleted_by: localStorage.getItem('lkjhgfdsa')
      }
      this.$store.dispatch('delete_activity_contact', data)
    }
  }
}
</script>

<style scoped>

</style>
